import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderComponent} from "../../order-manager/order/order.component";
import {ItemService} from "../../../services-otc/item.service";
import {catchError, throwError} from "rxjs";
import {NavBarComponent} from "../../../../nav-bar/nav-bar.component";

@Component({
    selector: 'app-remove-item',
    templateUrl: './remove-item.component.html',
    styleUrls: ['./remove-item.component.css'],
    standalone: false
})
export class RemoveItemComponent {


  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<OrderComponent>,
              private itemService: ItemService,
              public nav: NavBarComponent,
  ) {
  }

  cancelClearingItems() {
    this.dialogRef.close();
  }

  deleteItemById(){
    this.nav.toggleLoading(true);
    let itemObj = {
      id: this.data.itemId,
    };

    this.itemService.deleteOrderListItemById(itemObj.id).pipe(
        catchError(error => {
          console.error(error);
          return throwError(() => error);
        })
    ).subscribe(() => {
      this.dialogRef.close();
    });
  }
}